import styled from 'styled-components';
import { white } from 'styles/Colors';
import { OptionWrapper } from '../Option/OptionStyles';

export const TagCatcherThrowsWrapper = styled.div`
  background: ${white};
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.14);
  border-radius: 5px;
  background-color: ${white};
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  backdrop-filter: blur(20px);
  position: relative;

  ${OptionWrapper} {
    height: 68px;
    font-size: 13px;
    flex-direction: column;
    padding: 8px 12px;
    align-items: flex-start;
    width: 100%;
  }
`;

export const OptionTitle = styled.div`
  svg {
    position: absolute;
    top: 4px;
    right: 4px;
  }
`;
